import { DtoTrabajosDE } from '../../Lista/Domain/DtoTrabajosDE'
import { generarData } from './Processes'

export class UseCaseProcesses {
  generarData(trabajo: DtoTrabajosDE) {
    return generarData(trabajo)
  }
}